import { createSelector } from 'reselect';
import { orderBy } from 'lodash';


const getContracts = state => state.queues.common.appointmentForm.contracts;

export const canCreateAppointmentSelector = state => state.queues.common.appointmentForm.allowedContracts > 0;

export const getAllowedContracts = createSelector(
  getContracts,
  contracts => orderBy(contracts, [({ contract }) => contract.service.name.toLowerCase(), 'asc'])
    .map(({ contract }) => ({
      key: contract.contractId,
      value: contract.service.name,
    })),
);
